import CvPagination from './CvPagination.vue';
export { CvPagination };
export default CvPagination;
